import { API, graphqlOperation } from 'aws-amplify'

import { API_NAME, GRAPHQL_ROUTE } from '../config'
import { getIdToken } from '../utils'

export async function getTagValues(params) {
  try {
    const query = /* GraphQL */ `
      query getValuesOfTag($tag: String!) {
        getValuesOfTag(tag: $tag) {
          Name
        }
      }
    `
    const jwtToken = await getIdToken()
    const operation = graphqlOperation(query, params)
    const response = await API.post(API_NAME, GRAPHQL_ROUTE, {
      body: operation,
      headers: {
        Authorization: jwtToken
      }
    })

    if (response.errors) {
      throw Error(response.errors[0].message)
    }

    return {
      values: response.data.getValuesOfTag,
      error: null
    }
  } catch (err) {
    return { values: null, error: err.message }
  }
}
